import { Link } from 'react-router-dom';
import type { Cause as Code } from '@accounts/domain';
import { usePresence } from '@accounts/session';
import { Callout } from '@beyond-js/ui/react';
import { Heading } from '@accounts/ui';

/** The causes that are the application's to fix, so its developer is the one to tell */
const theirs: Code[] = ['client', 'document', 'redirect', 'unreachable', 'other'];

/**
 * Why an application could not even ask the person (`/connect?problem=<code>`), with the way on.
 *
 * Nothing reached the application and nothing was connected. An unknown application, an invalid
 * description and an unregistered redirect are refusals, in the danger tone, and their developer is the
 * one who can change them; a description that could not be read and Accounts not answering are
 * outages, in the warning tone (D40, D132). The way on is always the application: this interface does
 * not know where the person came from, so it offers nothing to follow but the overview.
 */
export function Cause({ cause, signed }: { cause: Code; signed: boolean }) {
	const { text } = usePresence();
	const outage = cause === 'unreachable' || cause === 'unavailable';
	const ways = [outage ? 'connect.problem.later' : 'connect.problem.again', theirs.includes(cause) ? 'connect.problem.developer' : null].filter((key): key is string => Boolean(key));

	return (
		<>
			<Heading title={text('connect.problem.title')} />
			<Callout tone={outage ? 'warning' : 'danger'} live title={text(`connect.problem.${cause}`)}>
				{ways.map(key => (
					<p key={key} className="mt-1 text-body text-ink-muted">
						{text(key)}
					</p>
				))}
			</Callout>
			{signed ? (
				<Link to="/" className="self-start underline">
					{text('connect.onward')}
				</Link>
			) : null}
		</>
	);
}
